import { render } from "./Home.vue?vue&type=template&id=3e3dbecd&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3e3dbecd"

export default script